import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import "./Label.scss";

const Label = ({ term, className }) => {
  const { t } = useTranslation();

  return <div className={classNames("label", className)}>{t(term)}</div>;
};

Label.propTypes = {
  className: PropTypes.string,
  term: PropTypes.string,
};

export default Label;
